export interface PmfScore {
    pmfScore: number;
    totalResponses: number;
    distribution: {
        veryDisappointed: number;
        somewhatDisappointed: number;
        notDisappointed: number;
    };
    percentages: {
        veryDisappointed: number;
        somewhatDisappointed: number;
        notDisappointed: number;
    };
}
